import React, { SetStateAction, useState } from "react";
import FormControl from "@material-ui/core/FormControl";
import { FieldExtensionComponentProps } from "@backstage/plugin-scaffolder-react";
import { Select, MenuItem } from "@material-ui/core";

interface ListEntry {
  title: string;
  value: string;
}

export const ListField = ({
  onChange,
  rawErrors,
  formData,
  schema,
}: FieldExtensionComponentProps<string>): JSX.Element => {
  const items = schema.items as ListEntry[];
  const [env, setEnv] = useState<string>(items[0].value);

  const entries = items.map((item: ListEntry) => {
    return (
      <MenuItem key={item.value} value={item.value}>
        {item.title}
      </MenuItem>
    );
  });

  return (
    <FormControl error={rawErrors?.length > 0 && !formData}>
      <Select
        value={env}
        label={schema.title}
        onChange={(event) => {
          const val = event.target.value;
          setEnv(val as SetStateAction<string>);
          onChange(val as string);
        }}
      >
        {entries}
      </Select>
    </FormControl>
  );
};
